/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1LocationCountriesIdMutationResponse,
  DeleteApiV1LocationCountriesIdPathParams,
  DeleteApiV1LocationCountriesId401,
  DeleteApiV1LocationCountriesId404,
  DeleteApiV1LocationCountriesId500,
} from "../../types/locationCountryController/DeleteApiV1LocationCountriesId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1LocationCountriesId } from "../../clients/locationCountryController/deleteApiV1LocationCountriesId.ts";

export const deleteApiV1LocationCountriesIdMutationKey = () =>
  [{ url: "/api/v1/location/countries/:id" }] as const;

export type DeleteApiV1LocationCountriesIdMutationKey = ReturnType<
  typeof deleteApiV1LocationCountriesIdMutationKey
>;

export function deleteApiV1LocationCountriesIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = deleteApiV1LocationCountriesIdMutationKey();
  return mutationOptions<
    DeleteApiV1LocationCountriesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCountriesId401
      | DeleteApiV1LocationCountriesId404
      | DeleteApiV1LocationCountriesId500
    >,
    { id: DeleteApiV1LocationCountriesIdPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteApiV1LocationCountriesId(id, config);
    },
  });
}

/**
 * @description Tenta excluir permanentemente o país. Se houver dependências, o país é desativado (soft delete). **(Requer Authorization para autenticação)**
 * @summary Excluir país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:id}
 */
export function useDeleteApiV1LocationCountriesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1LocationCountriesIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1LocationCountriesId401
        | DeleteApiV1LocationCountriesId404
        | DeleteApiV1LocationCountriesId500
      >,
      { id: DeleteApiV1LocationCountriesIdPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiV1LocationCountriesIdMutationKey();

  const baseOptions = deleteApiV1LocationCountriesIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1LocationCountriesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCountriesId401
      | DeleteApiV1LocationCountriesId404
      | DeleteApiV1LocationCountriesId500
    >,
    { id: DeleteApiV1LocationCountriesIdPathParams["id"] },
    TContext
  >;

  return useMutation<
    DeleteApiV1LocationCountriesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCountriesId401
      | DeleteApiV1LocationCountriesId404
      | DeleteApiV1LocationCountriesId500
    >,
    { id: DeleteApiV1LocationCountriesIdPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1LocationCountriesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCountriesId401
      | DeleteApiV1LocationCountriesId404
      | DeleteApiV1LocationCountriesId500
    >,
    { id: DeleteApiV1LocationCountriesIdPathParams["id"] },
    TContext
  >;
}
